module.exports = __webpack_public_path__ + "img/frame (273).ec3ded03.jpg";